import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO/meta block. Pass `meta` from `/api/v1/seo/*` OR raw overrides.
 * Arch §28.1.
 */
export default function SEO({
  title,
  description,
  canonical,
  image,
  og,
  jsonld,
  meta, // server-supplied object from /api/v1/seo/*
}) {
  const m = meta || {};
  const finalTitle = title || m.title || "ShreeHomes — The Real Place for Real Estate";
  const finalDesc = description || m.description ||
    "Browse published land, plot and property listings on ShreeHomes — The real place for real estate.";
  const finalCanonical = canonical || m.canonical;
  const finalImg = image || m.image;
  const ogObj = og || m.og || {};
  const ld = jsonld || m.jsonld;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      {finalCanonical && <link rel="canonical" href={finalCanonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={ogObj.title || finalTitle} />
      <meta property="og:description" content={ogObj.description || finalDesc} />
      <meta property="og:type" content={ogObj.type || "website"} />
      <meta property="og:site_name" content={ogObj.site_name || "ShreeHomes"} />
      {(ogObj.url || finalCanonical) && <meta property="og:url" content={ogObj.url || finalCanonical} />}
      {(ogObj.image || finalImg) && <meta property="og:image" content={ogObj.image || finalImg} />}

      {/* Twitter */}
      <meta name="twitter:card" content={finalImg ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      {finalImg && <meta name="twitter:image" content={finalImg} />}

      {/* JSON-LD structured data */}
      {ld && (
        <script type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      )}
    </Helmet>
  );
}
